const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get the current year

  return (
    <div>
      <footer className="main-footer clearfix">
        <strong>
          Copyright © 2024 - {currentYear}
          <i>
            <span style={{ color: "green" }}> Shawn Barber Shop</span>
          </i>
          .{" "}
        </strong>
        All rights reserved.
        <div className="float-right d-none d-sm-inline-block">
          <b>Version</b> 1.2.0
        </div>
      </footer>
      {/* Control Sidebar */}
      <aside>{/* Control sidebar content goes here */}</aside>
    </div>
  );
};

export default Footer;
